import { FIELD_TYPES } from "@hyro-components/fields/utils";

import { ACCOUNT_TYPE_OPTIONS } from "./AccountEditorConsts";

export const COLUMNS = {
  name: {
    id: "name",
    label: "Name",
  },
  accountId: {
    id: "accountId",
    label: "Account Id",
  },
  creator: {
    id: "creator",
    label: "Creator",
  },
  createdAt: {
    id: "createdAt",
    label: "Created At",
  },
  twilioId: {
    id: "twilioId",
    label: "Twilio Id",
  },
  timezone: {
    id: "timezone",
    label: "Timezone",
  },
  accountType: {
    id: "accountType",
    label: "Account Type",
    type: FIELD_TYPES.CHOOSE_AT_LEAST_ONE,
    options: ACCOUNT_TYPE_OPTIONS
  }
};

export const FILTERS = Object.values(COLUMNS).map((column) => ({
  key: column.id,
  label: column.label,
  type: column.type || FIELD_TYPES.TEXT,
  ...(column.options && { options: column.options })
}));
